<template>
	<div class="mymap">
		<zmlmenupage cn-name="" is-return="true"></zmlmenupage>
		
		<zmlmap></zmlmap>
	</div>
</template>
<script>
	import zmlmap from '@/components/map.vue'
  export default{
	name:'mymap',
    data(){
      return{

      }
    },
	components:{
		zmlmap
	}
  }
</script>
<style scoped="scoped">
.mymap{
	height: 100%;
}
.map{
	height: calc(100% - 74px) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/mymap.vue